// @flow
import { themeStyle } from '../colorPalettes'

import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const kratorplusThemeName = 'kratorplus'

export const themeKratorplus: ThemeType = {
  name: kratorplusThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.light:
        return lightTheme
      case themeStyle.dark:
        return darkTheme
      default:
        return lightTheme
    }
  },
}
